/* =============================================
   DESTAQUE EQUIPAMENTOS - THEME JS
   ============================================= */

(function () {
  'use strict';

  /* ---- Utility ---- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function formatMoney(cents) {
    return 'R$\u00a0' + (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  /* =============================================
     MOBILE MENU
     ============================================= */
  const mobileToggle = $('#mobile-menu-toggle');
  const mobileMenu = $('#mobile-menu');
  const mobileClose = $('#mobile-menu-close');
  const overlay = $('#overlay');

  function openMobileMenu() {
    mobileMenu && mobileMenu.classList.add('is-open');
    mobileMenu && mobileMenu.setAttribute('aria-hidden', 'false');
    overlay && overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    mobileMenu && mobileMenu.classList.remove('is-open');
    mobileMenu && mobileMenu.setAttribute('aria-hidden', 'true');
    overlay && overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
    closeCartDrawer();
  }
  mobileToggle && mobileToggle.addEventListener('click', openMobileMenu);
  mobileClose && mobileClose.addEventListener('click', closeMobileMenu);
  overlay && overlay.addEventListener('click', closeMobileMenu);

  /* =============================================
     CART DRAWER
     ============================================= */
  const cartDrawer = $('#cart-drawer');

  function openCartDrawer() {
    cartDrawer && cartDrawer.classList.add('is-open');
    overlay && overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }
  function closeCartDrawer() {
    cartDrawer && cartDrawer.classList.remove('is-open');
    overlay && overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  // Cart icon open
  $$('[data-open-drawer]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  });

  // Cart drawer close
  const cartDrawerClose = $('#cart-drawer-close');
  cartDrawerClose && cartDrawerClose.addEventListener('click', closeCartDrawer);

  function fetchCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCartDrawer(cart); })
      .catch(function (e) { console.error('Cart fetch error', e); });
  }

  function renderCartDrawer(cart) {
    const itemsEl = $('#cart-drawer-items');
    const totalEl = $('#cart-drawer-total');
    const countEl = $('.cart-count-bubble');
    if (countEl) {
      countEl.textContent = cart.item_count;
      countEl.setAttribute('aria-hidden', cart.item_count === 0 ? 'true' : 'false');
    }
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    if (!itemsEl) return;
    if (cart.items.length === 0) {
      itemsEl.innerHTML = '<p style="text-align:center;padding:40px;color:#999;font-size:14px;">Seu carrinho está vazio.</p>';
      return;
    }
    itemsEl.innerHTML = cart.items.map(function (item) {
      return '<div class="cart-drawer-item" style="display:flex;gap:12px;padding:12px 0;border-bottom:1px solid #f0f0f0;">' +
        '<img src="' + item.image + '" alt="' + item.title + '" style="width:64px;height:64px;object-fit:contain;background:#f9f9f9;border-radius:4px;padding:4px;">' +
        '<div style="flex:1;">' +
          '<p style="font-size:13px;font-weight:600;line-height:1.4;margin-bottom:4px;">' + item.product_title + '</p>' +
          (item.variant_title && item.variant_title !== 'Default Title' ? '<p style="font-size:11px;color:#999;margin-bottom:4px;">' + item.variant_title + '</p>' : '') +
          '<p style="font-size:14px;font-weight:800;color:var(--color-primary);">' + formatMoney(item.final_price) + '</p>' +
        '</div>' +
        '<button data-remove-key="' + item.key + '" style="color:#ccc;font-size:20px;line-height:1;padding:4px;" aria-label="Remover">&times;</button>' +
      '</div>';
    }).join('');

    // Remove buttons
    $$('[data-remove-key]', itemsEl).forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeFromCart(btn.dataset.removeKey);
      });
    });
  }

  function removeFromCart(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCartDrawer(cart); })
      .catch(function (e) { console.error(e); });
  }

  /* =============================================
     ADD TO CART — AJAX
     ============================================= */
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('.product-card__form, .product-form');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.textContent = 'Adicionando...'; }
    const data = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: data
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg> Adicionado!'; }
        setTimeout(function () {
          if (btn) btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg> Comprar';
        }, 2000);
        openCartDrawer();
      })
      .catch(function (err) {
        console.error(err);
        if (btn) { btn.disabled = false; btn.textContent = 'Tente novamente'; }
      });
  });

  /* =============================================
     PRODUCT PAGE - GALLERY
     ============================================= */
  $$('.product-media__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      const main = $('.product-media__main img');
      if (main) {
        main.src = thumb.querySelector('img').src.replace('_72x72', '_800x800').replace('_small', '_large');
        main.srcset = '';
      }
      $$('.product-media__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* =============================================
     PRODUCT PAGE - QUANTITY
     ============================================= */
  $$('.product-form__qty').forEach(function (wrap) {
    const minus = wrap.querySelector('[data-minus]');
    const plus = wrap.querySelector('[data-plus]');
    const input = wrap.querySelector('input');
    if (minus) minus.addEventListener('click', function () {
      const v = parseInt(input.value) || 1;
      if (v > 1) input.value = v - 1;
    });
    if (plus) plus.addEventListener('click', function () {
      const v = parseInt(input.value) || 1;
      input.value = v + 1;
    });
  });

  /* =============================================
     PRODUCT PAGE - TABS
     ============================================= */
  $$('.product-tab__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const target = btn.dataset.tab;
      $$('.product-tab__btn').forEach(function (b) { b.classList.remove('is-active'); });
      $$('.product-tab__content').forEach(function (c) { c.classList.remove('is-active'); });
      btn.classList.add('is-active');
      const content = $('#' + target);
      content && content.classList.add('is-active');
    });
  });

  /* =============================================
     CART PAGE - QTY UPDATE
     ============================================= */
  $$('.cart-item__qty-wrap').forEach(function (wrap) {
    const minus = wrap.querySelector('[data-minus]');
    const plus = wrap.querySelector('[data-plus]');
    const input = wrap.querySelector('input[name="updates[]"]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      const v = parseInt(input.value) || 1;
      input.value = Math.max(0, v - 1);
      updateCartItem(input.dataset.key, Math.max(0, v - 1));
    });
    if (plus) plus.addEventListener('click', function () {
      const v = parseInt(input.value) || 0;
      input.value = v + 1;
      updateCartItem(input.dataset.key, v + 1);
    });
  });

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function () { location.reload(); });
  }

  /* =============================================
     STICKY HEADER SHADOW
     ============================================= */
  const siteHeader = $('#site-header');

  if (siteHeader) {
    window.addEventListener('scroll', function () {
      
      // sombra (já existia)
      siteHeader.style.boxShadow = window.scrollY > 10 
        ? '0 4px 16px rgba(0,0,0,0.12)' 
        : '0 2px 8px rgba(0,0,0,0.08)';

      // 🔥 NOVO: modo compacto
      if (window.scrollY > 50) {
        siteHeader.classList.add('header--scrolled');
      } else {
        siteHeader.classList.remove('header--scrolled');
      }

    }, { passive: true });
  }

  /* =============================================
     FILTER ACCORDION
     ============================================= */
  $$('.filter-group__heading').forEach(function (heading) {
    heading.addEventListener('click', function () {
      const group = heading.closest('.filter-group');
      const opts = group.querySelector('.filter-group__options');
      if (!opts) return;
      const isOpen = opts.style.display !== 'none';
      opts.style.display = isOpen ? 'none' : 'flex';
      heading.querySelector('.filter-chevron') && (heading.querySelector('.filter-chevron').style.transform = isOpen ? 'rotate(0deg)' : 'rotate(180deg)');
    });
  });

  /* =============================================
     SCROLL TO TOP (optional)
     ============================================= */
  const scrollBtn = document.createElement('button');
  scrollBtn.id = 'scroll-top';
  scrollBtn.setAttribute('aria-label', 'Voltar ao topo');
  scrollBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="18 15 12 9 6 15"></polyline></svg>';
  scrollBtn.style.cssText = 'position:fixed;bottom:30px;left:20px;width:44px;height:44px;border-radius:50%;background:var(--color-primary);color:#fff;display:flex;align-items:center;justify-content:center;z-index:99;opacity:0;pointer-events:none;transition:opacity 0.3s;box-shadow:0 4px 12px rgba(0,0,0,0.2);';
  document.body.appendChild(scrollBtn);
  window.addEventListener('scroll', function () {
    scrollBtn.style.opacity = window.scrollY > 400 ? '1' : '0';
    scrollBtn.style.pointerEvents = window.scrollY > 400 ? 'all' : 'none';
  }, { passive: true });
  scrollBtn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });

  /* =============================================
     WHATSAPP FLOAT BUTTON
     ============================================= */
  const waNumber = document.documentElement.dataset.wa;
  if (waNumber) {
    const waBtn = document.createElement('a');
    waBtn.href = 'https://wa.me/' + waNumber;
    waBtn.target = '_blank';
    waBtn.rel = 'noopener';
    waBtn.setAttribute('aria-label', 'WhatsApp');
    waBtn.innerHTML = '<svg width="30" height="30" viewBox="0 0 24 24" fill="#fff"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>';
    waBtn.style.cssText = 'position:fixed;bottom:30px;right:30px;width:60px;height:60px;border-radius:50%;background:#25D366;display:flex;align-items:center;justify-content:center;z-index:100;box-shadow:0 4px 16px rgba(37,211,102,0.4);transition:transform 0.2s;';
    waBtn.addEventListener('mouseenter', function () { waBtn.style.transform = 'scale(1.1)'; });
    waBtn.addEventListener('mouseleave', function () { waBtn.style.transform = 'scale(1)'; });
    document.body.appendChild(waBtn);
  }

})();

/**
 * Cart Drawer - Altura dinâmica do header
 * Destaque Equipamentos
 *
 * INSTALAÇÃO:
 * Opção A (recomendado): Cole este conteúdo no final do theme.js
 * Opção B: Salve como asset (cart-header-height.js) e carregue no theme.liquid
 */

(function () {
  function updateHeaderHeight() {
    var header = document.getElementById('site-header');
    if (!header) return;
    var h = header.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--header-height', h + 'px');
  }

  // Atualiza na carga
  updateHeaderHeight();

  // Atualiza ao redimensionar (mobile/desktop) e ao fazer scroll
  // (o header compacto muda de altura ao scroll)
  window.addEventListener('resize', updateHeaderHeight, { passive: true });
  window.addEventListener('scroll', updateHeaderHeight, { passive: true });
})();